// javascript
import React, { useEffect, useRef, useState } from 'react';
import api from '../../helper/util/api';
import Autocomplete from './Autocomplete';

export default function PersonAutocomplete({ personType, person_data={}, onSelect, onChange, onBlur, label, name, placeholder, disabled, showBtn=true, showContact=true, acApiProps={} }) {
  const [options, setOptions] = useState([]);
  const [query, setQuery] = useState('');
  const [selectedName, setSelectedName] = useState('');
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newPerson, setNewPerson] = useState({ name: '', phone: '', email: '' });
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [loading, setLoading] = useState(false);

  const containerRef = useRef(null);
  const debounceRef = useRef(null);

  useEffect(() => {
    // initial load for type
    //fetchOptions('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personType]);

  useEffect(() => {
    setSelectedPerson(person_data);
    setSelectedName(person_data?.name || '');
    console.log("AC: ", personType, person_data)
  },[person_data?.name, person_data?.mobile])
  

  useEffect(() => {
    function handleClickOutside(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    }
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  async function fetchOptions(q) {
    setLoading(true);
    try {
      const res = await api.get('/ac-persons', { params: { person_type: personType, q, ...acApiProps } });
      setOptions(res.data || []);
      setShowSuggestions(res.data.length > 0 ? true : false)

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  function handleInputChange(val) {
    setSelectedName(val);
    setQuery(val);
    setShowSuggestions(true);
    
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchOptions(val);
    }, 300);
    
    onChange && onChange(val)

    // if user typed something that doesn't match an option, communicate null selection
    const match = options.find(o => o.name.toLowerCase() === val.toLowerCase());
    if (!match) {
      setSelectedPerson(null);
      onSelect && onSelect(null);
    }
  }

  async function handleSelectOption(opt) {
    console.log("handleSelectOption", opt)
    let selectedData = opt;
    setSelectedName(selectedData.name);
    setSelectedPerson(selectedData);
    setShowSuggestions(false);
    setQuery('');
    
    try {
      const res = await api.get('/persons', { params: { person_type: personType, id: selectedData.id } });
      selectedData = res.data.user;
      setSelectedName(selectedData.name);
      setSelectedPerson(selectedData);
    } catch (err) {
      console.error(err);
    } 

    onSelect && onSelect(selectedData);
  }

  const handleBlur = (e) => {
    setShowSuggestions(false);
    onBlur && onBlur(e);
  }

  async function handleAddNew() {
    if (!newPerson.name || newPerson.name.trim() === '') return alert('Name required');
    try {
      const payload = { ...newPerson, person_type: personType };
      const res = await api.post('/add-person', payload);
      // refresh options and auto-select created person
      //await fetchOptions(res.data.name);
      setShowAddModal(false);
      setSelectedName(res.data.name);
      setSelectedPerson(res.data);
      onSelect && onSelect(res.data);
      setNewPerson({ name: '', phone: '', email: '' });
    } catch (err) {
      console.error(err);
      alert('Failed to add person');
    }
  }

  return (
    <div ref={containerRef} style={{ position: 'relative', }}>
      
      {
        //{... showBtn ? {btnText:"Add", onClick:() => {setShowAddModal(true);setShowSuggestions(false)}} : {}}
      }
      <Autocomplete label={label} name={name} disabled={disabled} value={selectedName || query} placeholder={placeholder} 
      data={{showSuggestions, loading, options}} //{... showBtn ? {btnText:"Add", onClick:() => {setShowAddModal(true);setShowSuggestions(false)}} : {}}
      onChange={handleInputChange} onSelect={handleSelectOption} onBlur={handleBlur} />
      {showContact && (
        <>
          {selectedPerson ? (
            <div style={{ marginTop: 6 }} className="small-muted">Phone: {selectedPerson.mobile || '-'}</div>
          ) : (
            <div style={{ height: "20px" }}></div>
          )}
        </>
      )}
      {showAddModal && (
        <div className="modal" role="dialog" aria-modal="true">
          <div className="modal-card">
            <h4 style={{ marginTop: 0, marginBottom: 8 }}>Add {personType}</h4>

            <div className="form-group">
              <label className="label">Name</label>
              <input className="input" value={newPerson.name} onChange={e => setNewPerson({ ...newPerson, name: e.target.value })} />
            </div>

            <div className="form-group">
              <label className="label">Phone</label>
              <input className="input" value={newPerson.phone} onChange={e => setNewPerson({ ...newPerson, phone: e.target.value })} />
            </div>

            <div className="form-group">
              <label className="label">Email</label>
              <input className="input" value={newPerson.email} onChange={e => setNewPerson({ ...newPerson, email: e.target.value })} />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button className="btn-small ghost" onClick={() => setShowAddModal(false)}>Cancel</button>
              <button className="btn-small" onClick={handleAddNew}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
